<template>
  <form
    ref="form"
    :method="method"
    :action="action"
    @submit.prevent="handleSubmit"
    scope="credit-card-form"
  >
    <loading-full-page :active="showLoading"></loading-full-page>

    <div class="contentBody">
      <div class="contentBody__section">
        <input type="hidden" name="_token" :value="token">
        <input type="hidden" name="cpno" :value="cpno">
        <input type="hidden" name="order_id" :value="orderId">
        <input type="hidden" name="merchant_id" :value="merchantId">
        <input type="hidden" name="service_id" :value="serviceId">
        <input type="hidden" name="cc_number" ref="cc_number">
        <input type="hidden" name="token" ref="token">
        <input type="hidden" name="tokenKey" ref="tokenKey">
        <input type="hidden" name="cardbrandCode" ref="cardbrandCode">
        <form-credit-card
          label="カード番号"
          name="ccNumber"
          v-model="ccNumber"
          :validation="{ rules: {
        required: true,
        credit_card: true
        } }"
          @change="checkRequiredFields"
          @blur="checkRequiredFields"
        ></form-credit-card>

        <form-credit-expire
          name
          label="カード有効期限"
          month-name="cc_expiration_m"
          year-name="cc_expiration_y"
          v-model="ccExpiration"
          :validation="{ rules: {
          required: true
          } }"
          @change="checkRequiredFields"
          @blur="checkRequiredFields"
          @input="checkRequiredFields"
        ></form-credit-expire>

        <div class="securityCode">
          <form-input
            label="セキュリティコード"
            name="security_code"
            v-model="securityCode"
            type="tel"
            input-width="72px"
            :validation="{ rules: {
              required: true,
              numeric: true,
              max: 4
              } }"
            @change="checkRequiredFields"
            @blur="checkRequiredFields"
          ></form-input>
          <div class="securityCode__question" @click="toggleAboutSecurityCode">
            <img width="20" height="20" src="/static/img/icons/question.svg">
          </div>
          <div class="securityCode__about media" :data-visible="visibleAboutSecurityCode">
            <div class="media__image">
              <img src="/static/img/security-code.png" width="48" height="30">
            </div>
            <div class="media__content">
              <p>セキュリティコードはカード裏面に記載されている３桁または、表面に記載されている４桁の番号です。</p>
            </div>
          </div>
        </div>

        <label class="confirmTerms u-mb-t-2" v-if="isSaveCard">
          <input type="checkbox" class="confirmTerms__checkbox" name="cust_manage_flg" value="1">
          <span class="confirmTerms__label">カード情報を登録する</span>
        </label>
      </div>
    </div>
    <slot></slot>
    <div class="contentFooter">
      <!-- 戻るボタン -->
      <form v-if="actionBack" class="paymentBtnGroup u-mg-b-2 u-mg-r-1" :method="method" :action="actionBack">
          <button class="paymentBtnGroup__btn">戻る</button>
      </form>
      <div class="paymentBtnGroup">
        <button
          type="button"
          class="btn"
          @click="openModal()"
          data-block="true"
          data-color="brand"
          :disabled="!this.isSubmittable"
        >このカードで購入</button>
      </div>
    </div>

    <app-modal-simple
      title
      :active="isShowModal"
      @close="closeModal()"
      :location-path="ga_location"
      :showheader="true"
      :showfooter="false"
      class="simple payment"
      :close="true"
    >
      <div slot="content" class="content">
        <div class="content__inner">
          <div class="caption u-tx-center">
            <span class="u-tx-bold u-tx-size-16 u-tx-brand">購入内容の確認</span>
          </div>
          <div class="description u-tx-brand">
            <span>{{itemName}}</span>
          </div>
          <hr class="contentSeparatorSection gray-10 u-mg-t-2 u-mg-b-2">
          <div class="content__price">
            <span class="u-width-10">価格</span>
            <div class="u-width-10 u-tx-right">
              <span class="content__value">¥{{ itemPrice | addComma }}</span>
              <span class="tax">(税込)</span>
            </div>
          </div>
          <hr class="contentSeparatorSection gray-10 u-mg-t-2 u-mg-b-3">

          <div class="type u-mg-b-3">
            <span class="u-width-10">お支払い方法</span>
            <span class="u-width-10 u-tx-right">クレジットカード</span>
          </div>
          <div class="u-mg-l-1">
            <div class="flexbox u-mg-b-2">
              <span class="label u-tx-size-13">カード番号</span>
              <span class="content__value colorBlk">{{trimCardNum(ccNumber)}}</span>
            </div>
            <div class="flexbox">
              <span class="label u-tx-size-13">カード有効期限</span>
              <span class="content__value colorBlk">20{{ccExpiration.year}}/{{ccExpiration.month}}</span>
            </div>
          </div>
          <hr class="contentSeparatorSection gray-10 u-mg-t-2 u-mg-b-4">
        </div>

        <p v-if="sbpsPaymentError" class="u-tx-danger u-tx-center">申し訳ありませんがご入力頂いたカード情報は現在利用できません。</p>

        <!-- ボタン -->
        <div class="actionarea">
          <div class="button default" @click="closeModal()">
            <span>修正</span>
          </div>
          <button
            href
            class="button brand-0"
            type="submit"
            @click="handleSubmit"
            :disabled="processing"
          >
            <span>購入を確定</span>
          </button>
        </div>
      </div>
    </app-modal-simple>
  </form>
</template>

<script>
let initialLocation = location.origin + location.pathname
export default {
  name: 'credit-card-form',
  data() {
    return {
      ccNumber: '',
      ccExpiration: {},
      securityCode: '',
      token: window.Laravel.csrfToken,
      cpno: window.Laravel.cpno,
      tokenResponse: {},
      sbpsPaymentError: false,
      visibleAboutSecurityCode: false,
      isShowModal: false,
      ga_location: initialLocation,
      isSubmittable: false,
      err: this.$validator.errors.items,
      requiredFieldsBool: false,
      showLoading: false,
      processing: false
    }
  },
  props: {
    method: String,
    action: String,
    actionBack: String,
    orderId: String,
    merchantId: String,
    serviceId: String,
    custManageFlg: [String, Number],
    itemName: String,
    itemPrice: [String, Number],
    isSaveCard: { type: Boolean, default: false }
  },
  watch: {
    err() {
      this.isSubmittable = this.err.length <= 0 && this.requiredFieldsBool ? true : false
    }
  },
  methods: {
    checkRequiredFields() {
      this.requiredFieldsBool = this.ccNumber.length > 0 && this.ccExpiration.year.length > 0 && this.ccExpiration.month.length > 0 && this.securityCode.length > 0 ? true : false
      this.checkSubmittable()
    },
    toggleAboutSecurityCode() {
      this.visibleAboutSecurityCode = !this.visibleAboutSecurityCode
      if (this.visibleAboutSecurityCode) {
        setTimeout(this.toggleAboutSecurityCode, 5000)
      }
    },
    afterGenerateToken(response) {
      if (response.result == 'OK') {
        this.showLoading = true
        new Promise(resolve => {
          this.sbpsPaymentError = false
          const { tokenResponse } = response
          this.$refs.token.value = tokenResponse.token
          this.$refs.tokenKey.value = tokenResponse.tokenKey
          this.$refs.cardbrandCode.value = tokenResponse.cardbrandCode
          // カード情報をマスクされた番号で上書き
          this.$refs.cc_number.value = tokenResponse.maskedCcNumber
          resolve()
        }).then(() => {
          this.$refs.form.submit()
        })
      } else {
        this.showLoading = false
        this.sbpsPaymentError = true
      }
    },
    handleSubmit($event) {
      this.processing = true
      $event.preventDefault()

      this.$validator.validateAll().then(result => {
        if (result === false) {
          const errors = this.$validator.errors.items
          const $errorsElm = $(`[data-vv-id="${errors[0].id}"]`)
          let top = 0
          if ($errorsElm.css('display') === 'none') {
            $errorsElm
              .css({
                height: '1px'
              })
              .show()
            top = $errorsElm.offset().top
            $errorsElm.hide()
          }
          $('html, body').animate(
            {
              scrollTop: $errorsElm[0] ? top - 80 : 0
            },
            300
          )

          this.showLoading = false
        } else {
          window.com_sbps_system.generateToken(
            {
              merchantId: this.merchantId,
              serviceId: this.serviceId,
              ccNumber: this.ccNumber,
              ccExpiration: `20${this.ccExpiration.year}${
                this.ccExpiration.month
                }`,
              securityCode: this.securityCode
            },
            this.afterGenerateToken
          )
        }
      })
    },
    openModal() {
      // GA送信
      window.gtag('event', 'PaymentCheckModal', {
        page_location: initialLocation + '/paymentcheck'
      })
      this.isShowModal = true
      this.sbpsPaymentError = false
    },
    closeModal() {
      this.processing = false
      this.isShowModal = false
    },
    checkSubmittable() {
      this.isSubmittable = this.err.length <= 0 && this.requiredFieldsBool ? true : false
    },
    trimCardNum(str = '', length = 0) {
      return `************${str.slice(-4)}`
    },
  }
}
</script>

<style lang="scss" scoped>
.securityCode {
  position: relative;
  &__question {
    position: absolute;
    left: 88px;
    top: 30px;
    cursor: pointer;
  }
  &__about {
    position: absolute;
    background: rgba(0, 0, 0, 0.7);
    color: #fff;
    padding: 8px;
    z-index: 2;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px;
    border-radius: 4px;
    left: 120px;
    top: 0;
    align-items: center;
    pointer-events: none;
    opacity: 0;
    transition: opacity 250ms ease-in-out;
    &[data-visible='true'] {
      opacity: 1;
      pointer-events: auto;
    }
    .media__content p {
      font-size: 10px;
      line-height: 14px;
    }
  }
}

.contentFooter {
  display: flex;
}
.paymentBtnGroup {
  width: 100%;
  display: flex;
  &__btn {
    appearance: none;
    background-color: #ffffff;
    border: 1px solid #000;
    border-radius: 0;
    color: #000;
    cursor: pointer;
    vertical-align: middle;
    padding: 0 8px;
    font-family: 'Hiragino Kaku Gothic Pro', YakuHanJP, 'source-han-sans-japanese', -apple-system, BlinkMacSystemFont, sans-serif;
    font-size: 14px;
    outline: none;
    height: 40px;
    line-height: 38px;
    text-align: center;
    text-decoration: none;
    white-space: nowrap;
    width: 100%;
  }
}

.modal {
  &.simple {
    .actionarea {
      display: flex;
      margin: 0 -7px;

      .button {
        width: 100%;
        outline: 0;
        margin: 0 7px;
      }
    }
  }
  // payment_modal
  &.payment {
    .close {
      width: 48px;
      float: right;
    }

    .modal__content {
      border-radius: 2px;
    }

    .modal__header {
      position: absolute;
      width: 100%;
    }

    .modal__body {
      .content {
        padding: 24px 16px;

        &__inner {
          .caption {
            line-height: 16px;
            margin-bottom: 24px;
          }
          .type {
            display: flex;
          }
          .flexbox {
            display: flex;
          }
          .label {
            width: 100%;
          }
        }
      }
    }
  }
}
.content__price {
  display: flex;
}
.content__value {
  width: 100%;
  text-align: right;
}
.colorBlk {
  color: #000000;
}
.confirmTerms {
  justify-content: left;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Payment/CreditCardForm.vue